import { cn } from '~/lib/utils'
import {
  ChecklistEvidenciaMockup,
  FeedMediaMockup,
  IaConversaMockup,
  InboxRealMockup,
  VisitaFotosMockup,
} from './mockups/features'
import { ScrollReveal } from './scroll-reveal'
import { TruchetField } from './truchet-field'

/*
 * The five feature rows, each carrying the mockup that won its round in the
 * /lp/mockups workshop — real screens with the app's own vocabulary and
 * photographs of the site, not placeholder bars.
 */
const ROWS = [
  {
    body: 'Veja no que as obras e os projetos avançaram sem abrir um por um. O que mudou desde ontem chega até você, com as fotos que vieram da obra.',
    flip: false,
    Mockup: FeedMediaMockup,
    title: 'Um feed do que andou em cada projeto',
  },
  {
    body: 'Abra a obra no celular, anote no lugar, fotografe a pendência e tudo cai no projeto antes de você voltar para o escritório.',
    flip: true,
    Mockup: VisitaFotosMockup,
    title: 'A visita técnica vai com você',
  },
  {
    body: 'Recebimento de obra, vistoria do cliente, conferência de instalação. Cada item responde conforme, não conforme ou N/A — com foto e nota como evidência.',
    flip: false,
    Mockup: ChecklistEvidenciaMockup,
    title: 'Checklists prontos para a entrega',
  },
  {
    body: 'Pergunte o que ficou pendente na obra, peça o rascunho da retrospectiva da semana, ache a decisão daquela visita. A resposta vem com as fontes do próprio escritório.',
    flip: true,
    Mockup: IaConversaMockup,
    title: 'Uma IA que conhece o escritório',
  },
  {
    body: 'Menos notificação à toa. O que importa sobe para o topo, e você só é avisado quando alguém de fato precisa de você.',
    flip: false,
    Mockup: InboxRealMockup,
    title: 'Uma caixa de entrada que separa sinal de ruído',
  },
] as const

/** Alternating feature rows over a quiet Truchet arc field. */
export const FeatureRowsSection = () => (
  <section className="relative overflow-hidden py-24">
    <TruchetField
      className="absolute inset-0 h-full w-full text-[#0b0b0d] opacity-[0.05]"
      seed="feature-rows"
    />
    <div className="relative mx-auto flex max-w-[1120px] flex-col gap-28 px-6">
      {ROWS.map(({ title, body, Mockup, flip }) => (
        <div className="grid items-center gap-12 md:grid-cols-2 md:gap-16" key={title}>
          <ScrollReveal className={cn(flip && 'md:order-2')}>
            <h3 className="max-w-[420px] font-display text-[#0b0b0d] text-[clamp(30px,4vw,42px)] leading-[1.12] tracking-[-0.01em]">
              {title}
            </h3>
            <p className="mt-5 max-w-[420px] text-[#8a8a90] text-[clamp(16px,2.2vw,21px)] leading-relaxed">
              {body}
            </p>
          </ScrollReveal>
          <ScrollReveal className={cn(flip && 'md:order-1')} delay={120}>
            <Mockup />
          </ScrollReveal>
        </div>
      ))}
    </div>
  </section>
)
